import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { ClientFilterFragmentDoc } from '../../fragment/generated/ClientFilter';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ClientFilterQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  filters?: Types.InputMaybe<Types.ClientsFilters>;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ClientFilterQuery = { clients: { pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id: string, clientName: string, clientIcon?: { url?: string | null } | null } }> | null } };


export const ClientFilterDocument = /*#__PURE__*/ gql`
    query clientFilter($first: Float, $filters: ClientsFilters, $sort: [SortType!], $after: String) {
  clients(first: $first, filters: $filters, sort: $sort, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...ClientFilter
      }
    }
  }
}
    ${ClientFilterFragmentDoc}`;

export function useClientFilterQuery(options?: Omit<Urql.UseQueryArgs<ClientFilterQueryVariables>, 'query'>) {
  return Urql.useQuery<ClientFilterQuery, ClientFilterQueryVariables>({ query: ClientFilterDocument, ...options });
};